import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

export const DASHBOARD_ACTION_BUTTON_REQUIRED_ONE_OF_FEATURES = [
    RbacFeature.dashboardCopySubmissionLink,
    RbacFeature.dashboardActivateDeactivateEntity,
    RbacFeature.dashboardPauseEntity,
    RbacFeature.dashboardViewPendingActions,
    RbacFeature.dashboardViewSubmissionHistory,
];
